import { createAction } from 'redux-actions';
export var markEditorFocused = createAction('DA_EDITOR.MARK_FOCUSED', function (editorKey) { return ({ editorKey: editorKey }); });
export var markEditorInactive = createAction('DA_EDITOR.MARK_INACTIVE', function (editorKey) { return ({ editorKey: editorKey }); });
//# sourceMappingURL=actionCreators.js.map